import { NotificationDetailQueue } from 'api/resources/models/AutoGenerated';
import { formatDateTime } from 'utils/helpers';

 export function renderCustomCell({
    baseRender,
    headerId,
    row,
  }: {
    baseRender: () => JSX.Element;
    headerId: keyof NotificationDetailQueue;
    row: NotificationDetailQueue;
  }) {
    if (headerId == 'readDate' && row.readDate)
      return <>{formatDateTime(row.readDate)}</>;
    if (headerId == 'receivedDate' && row.receivedDate)
      return <>{formatDateTime(row.receivedDate)}</>;
    return baseRender();
  }

